/** Partner / admin event workflow status chip colors — one distinct palette per status. */
export const EVENT_APPROVAL_STATUS_STYLES = {
  draft: { label: 'Draft', bgcolor: '#F3F4F6', color: '#4B5563' },
  pending: { label: 'Pending', bgcolor: '#FFF8E1', color: '#F57F17' },
  submitted: { label: 'Submitted', bgcolor: '#E8EAF6', color: '#3949AB' },
  requested: { label: 'Changes Requested', bgcolor: '#FFF3E0', color: '#E65100' },
  changes_requested: { label: 'Changes Requested', bgcolor: '#FFF3E0', color: '#E65100' },
  rejected: { label: 'Rejected', bgcolor: '#FFEBEE', color: '#C62828' },
  approved: { label: 'Approved', bgcolor: '#E8F5E9', color: '#2E7D32' },
  published: { label: 'Published', bgcolor: '#E0F7FA', color: '#00838F' },
  live: { label: 'Live', bgcolor: '#E3F2FD', color: '#1565C0' },
  completed: { label: 'Completed', bgcolor: '#EDE7F6', color: '#5E35B1' },
  archived: { label: 'Archived', bgcolor: '#ECEFF1', color: '#546E7A' },
};

const formatUnknownStatusLabel = (status) =>
  String(status)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getEventApprovalStatusStyle = (status) => {
  const key = String(status ?? '').toLowerCase();
  return (
    EVENT_APPROVAL_STATUS_STYLES[key] ?? {
      label: status ? formatUnknownStatusLabel(status) : '—',
      bgcolor: '#F3F4F6',
      color: '#4B5563',
    }
  );
};
